import { Injectable } from '@angular/core';
import { ENV } from '@app/env';
import { NavParams, LoadingController, ToastController, AlertController, ModalController, ActionSheetController, Platform } from 'ionic-angular';
import { isObject, isString } from "util";
import { TranslateCodePipe } from '../pipes/translate';
import { Translate2Pipe } from '../pipes/translate2';
import { AngularFireDatabase } from 'angularfire2/database';
import { EntityDataType } from '../models/shopping-cart.model';

@Injectable()
export class UtilitiesProvider {

  constructor(
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private actionSheetCtrl: ActionSheetController,
    private platform: Platform,
    private modalCtrl: ModalController,
    private translatePipe: TranslateCodePipe,
    private translate2Pipe: Translate2Pipe,
    public afDb: AngularFireDatabase,
  ) { }

  setLoading(message: string = null) {
    let load = this.loadingCtrl.create({
      dismissOnPageChange: true
    });

    if (message) {
      load.setContent(message);
    }

    load.present();

    return load;
  }

  public getEntityData(type: string, id: string, eventId: string = null) {
    const childPath = this.getEntityPath(type, id, eventId);
    return this.afDb.object(childPath).query.once('value').then(snap => snap.val());
  }

  public getEntityDataObservable(type: string, id: string, eventId: string = null) {
    const childPath = this.getEntityPath(type, id, eventId);
    return this.afDb.object<EntityDataType>(childPath).valueChanges();
  }

  public getEntityPath(type: string, id: string, eventId: string = null): string {
    const hasEventId = this.validateEventIdParam(eventId);
    const path = hasEventId ?
      this.getEntityEventPathByType(type, eventId) :
      this.getEntityPathByType(type);
    return `${path}/${id}`;
  }

  public getEntityListDataSnap(ref: string = null) {
    return this.afDb.list(ref).query.once('value').then(snap => snap.val());
  }

  public getEntityObjectDataSnap(ref: string): Promise<any> {
    return this.afDb.object(ref).query.once("value").then(snap => snap.val());
  }

  shareURL() {
    let newVariable = (window.navigator as any)
    if (newVariable.share) {
      newVariable.share({
        title: 'title',
        text: 'description',
        url: 'https://soch.in//',
      })
        .then(() => this.consoleDecorator('Successful share', true))
        .catch((error) => this.consoleError('Error sharing', error));
    } else {
      alert('share not supported');
    }
  }

  validateEventId(params: NavParams) {
    return (
      params.get('eventId') !== '--' &&
      params.get('eventId') !== '' &&
      params.get('eventId') !== undefined
    );
  }



  validateEventIdParam(eventId: string) {
    return (
      eventId !== '--' &&
      eventId !== '' &&
      eventId !== undefined &&
      eventId !== null
    );
  }

  consoleLog(text = "", data: any) {
    if (ENV.mode === 'Development') {
      console.log(text, data);
    }
  }

  consoleWarn(text = "", data: any) {
    if (ENV.mode === 'Development') {
      console.warn(text, data);
    }
  }

  consoleDecorator(text = "", data: any, color = 'green') {
    if (ENV.mode === 'Development') {
      console.log(`%c ${text}`, `background: ${color}; color: white; display: block;`, data);
    }
  }

  consoleGlobal(text = "", data: any) {
    if (ENV.mode === 'Development') {
      console.log(`%c ${text}`, `background: orange; color: white; display: block;`, data);
    }
  }

  consoleError(text = "", data: any) {
    if (ENV.mode === 'Development') {
      console.log(`%c ${text}`, `background: red color: red; display: block;`, data);
    }
  }

  consoleErrorAll(text = "", data: any = []) {
    console.log(`%c [Err] ${text}`, `background: #c90861 color: white; display: block;`, data);
  }

  consoleLogAll(text = "", data: any = []) {
    console.log(`%c ${text}`, `background: #2daa4b; color: white; display: block;`, data);
  }

  public async translateTextOrObject(textToTransalate: string | Object) {
    if (isObject(textToTransalate)) {
      return await this.translate2Pipe.transform(textToTransalate);
    } else {
      return await this.translatePipe.transform(textToTransalate);
    }
  }

  searchItem(ev: string, item: any, arrStrg: any[]) {
    let state = false;
    if (ev) {
      arrStrg.forEach(s => {
        if (isObject(s)) {
          let keys = Object.keys(s);
          keys.forEach(k => {
            s[k].forEach(a => {
              if (item[k][a]) {
                if (item[k][a].toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(ev.toLowerCase()) > -1) {
                  state = true;
                }
              }
            });
          });
        } else if (isString(s)) {
          if (item[s]) {
            if (item[s].toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(ev.toLowerCase()) > -1) {
              state = true;
            }
          }
        } else {
          state = true;
        }
      });
    } else {
      state = true;
    }

    return state;
  }

  validateIsEmpty(param) {
    return (
      param !== '' &&
      param !== undefined
    );
  }

  generateRamdomKey() {
    return this.afDb.createPushId();
  }

  getBrowser() {
    let userAgent = this.platform.userAgent();
    let browsers = { chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i };

    for (let key in browsers) {
      if (browsers[key].test(userAgent)) {
        return key;
      }
    };
    return 'unknown';
  }

  getDevice(device: 'ios' | 'core' | 'ipad' | 'iphone' | 'mobile' | 'mobileweb' | 'phablet' | 'tablet' | 'android' | 'windows') {
    return this.platform.is(device);
  }

  getInfoUserDevice() {
    return {
      browser: this.getBrowser(),
      userAgent: this.platform.userAgent()
    }
  }

  async setToast(message, duration: number = 3000, position: string = 'bottom') {
    return this.toastCtrl.create({
      message: await this.translatePipe.transform(message),
      duration,
      position
    }).present();
  }

  public async setToastStatic(message, buttonCloseText: string = 'Ok', position: string = 'bottom') {
    return this.toastCtrl.create({
      message: await this.translatePipe.transform(message),
      showCloseButton: true,
      closeButtonText: await this.translatePipe.transform(buttonCloseText),
      position
    }).present();
  }

  get alert() {
    return this.alertCtrl;
  }

  get actionSheet() {
    return this.actionSheetCtrl;
  }

  public async presentAlert(t: string, m: string, buttons: any[] = [], cancelBtnText = 'Ok', cancelBtn = true) {
    let title = await this.translateTextOrObject(t);
    let message = await this.translateTextOrObject(m);
    if (cancelBtn) {
      const defaultCancelButton = { text: await this.translateTextOrObject(cancelBtnText), role: 'cancel' };
      buttons = [defaultCancelButton, ...buttons];
    }
    return this.alert.create({
      title,
      message,
      cssClass: '',
      buttons,
    }).present();
  }

  get toast() {
    return this.toastCtrl;
  }

  public async presentToast(message: string, duration = 3000, position: 'top' | 'middle' | 'bottom' = 'bottom') {
    return this.toast.create({
      message: await this.translateTextOrObject(message),
      duration,
      position
    }).present();
  }

  get modal() {
    return this.modalCtrl;
  }

  get isPaymentMethods() {
    switch (ENV.payment_provider) {
      case 'payu':
      case 'fake':
        return false;
      default:
        return true;
    }
  }

  private getEntityPathByType(type: string): string {
    const client = ENV.client;
    switch (type) {
      case 'Event':
        return `/Clients/${client}/EventList`;
      case 'Staff':
        return `/ClientList/${client}/Staff`;
      case 'CommercialSample':
        return `/Clients/${client}/CommercialSamples`;
      default:
        throw new Error('Invalid type on get entity child by type function');
    }
  }

  private getEntityEventPathByType(type: string, eventId: string): string {
    const client = ENV.client;
    switch (type) {
      case 'Event':
        return `/Clients/${client}/EventList`;
      case 'Staff':
        return `/Clients/${client}/Events/${eventId}/Staff`;
      case 'CommercialSample':
        return `/Clients/${client}/Events/${eventId}/CommercialSamples`;
      default:
        throw new Error('Invalid type on get entity child by type function');
    }
  }

  public getStaffData(id: string) {
    return this.afDb.object(`/Clients/${ENV.client}/Staff/${id}`)
      .query.once('value').then(snap => snap.val());
  }

}



// WEBPACK FOOTER //
// ./src/providers/utilities.ts